import React from 'react';

import ModalFileImport from '../ModalFileImport';
import ModalFileLoading from '../ModalFileLoading';

import { useSelector } from 'react-redux';
import useMovimentacao from '../../../hooks/useMovimentacao';

const ImportarListas = ({
  acaoAtual,
  invalidCallback,
  openFileImport,
  openFileLoading,
  onClickFileImport,
  onClickFileLoading,
  handleFiles,
  isSuccess,
  files,
  handleCancel,
  setAfterLoadingCallback,
  loading,
}) => {
  const { usuario } = useSelector((state) => state.auth);
  const { setContentText, setModeloPadrao, setValidacao, setAfterLoading } =
    useMovimentacao();

  return (
    <>
      <ModalFileImport
        contentText={setContentText(acaoAtual)}
        modeloPadrao={setModeloPadrao(acaoAtual)}
        importFiles={(_) => _}
        isOpen={openFileImport}
        onClick={onClickFileImport}
        setListaFiles={(newFiles) => {
          handleFiles(newFiles);
        }}
        maxQuantityFiles={setValidacao(acaoAtual)?.maxQuantityFiles}
        maxSizeFiles={setValidacao(acaoAtual)?.maxSizeFiles}
        validExtension={setValidacao(acaoAtual)?.validExtension}
        applyValidation
        invalidCallback={invalidCallback}
      />
      <ModalFileLoading
        finishedLoadingFiles={setAfterLoading(
          acaoAtual,
          setAfterLoadingCallback,
          usuario
        )}
        onClick={onClickFileLoading}
        isOpen={openFileLoading}
        isSuccess={isSuccess}
        files={files}
        onClickCancel={handleCancel}
        loading={loading}
      />
    </>
  );
};

export default ImportarListas;
